(function InfogramLoader() {
  const s = document.createElement('script');
  s.async = 1;
  s.id = 'infogram-async';
  document.head.appendChild(s);
  s.src = 'https://e.infogram.com/js/dist/embed-loader-min.js';
})();
